import { __assign } from "tslib";
import React from 'react';
import InternalAutosuggest from './internal';
import { getExternalProps } from '../internal/utils/external-props';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
var Autosuggest = React.forwardRef(function (props, ref) {
    var baseComponentProps = useBaseComponent('Autosuggest');
    var externalProps = getExternalProps(props);
    return React.createElement(InternalAutosuggest, __assign({}, externalProps, baseComponentProps, { ref: ref }));
});
applyDisplayName(Autosuggest, 'Autosuggest');
export default Autosuggest;
//# sourceMappingURL=index.js.map